import { toObjectMap } from "@@/utilities/dictionary";
import { z } from "zod";

const orderConfirmationOptions = ["ON_REQUEST", "AUTO"] as const;
type OrderConfirmationOption = (typeof orderConfirmationOptions)[number];
const orderConfirmationOption = toObjectMap<OrderConfirmationOption>([
    ...orderConfirmationOptions,
]);
const orderConfirmationOptionZodSchema = z.enum(orderConfirmationOptions);
export {
    orderConfirmationOptions,
    orderConfirmationOption,
    orderConfirmationOptionZodSchema,
};
export type { OrderConfirmationOption };
